import { Application } from './application/application.types';

export * from './application/application.types';

export type ApplicationsResponse = {
  payload: Application[];
  error: boolean;
  type: string;
};
